export default {
  btc__invoice: 'Инвойс',
  btc__time_remaining: 'Срок жизни инвойса',
  btc__amount: 'Сумма',
  btc__amount_to_pay: 'Сумма к оплате',
  btc__exchange_rate: 'Курс валют ({from}/{to})',
  btc__network_address: '{currency} ({network}) адрес для оплаты',
  btc__copy: 'Копировать',
  btc__return_to_site: 'Вернуться на сайт',
};
